<script setup lang="ts">
import type { FooterSocialLinkItem } from '@fondof-ui/types'

import {
  SocialFacebookIcon,
  SocialInstagramIcon,
  SocialPinterestIcon,
} from '@fond-of/fondof-icons'

const props = defineProps<{
  link: FooterSocialLinkItem
}>()

const socialMediaIcons = {
  pinterest: SocialPinterestIcon,
  facebook: SocialFacebookIcon,
  instagram: SocialInstagramIcon,
}
</script>

<template>
  <span
    class="block flex h-12 w-12 items-center justify-center rounded-full border-2 border-black text-black transition-all duration-200 hover:border-black"
  >
    <a
      :key="props.link.name"
      :href="props.link.url"
      data-gtm-attr="button_footer"
      :data-gtm-label="props.link.name"
      target="_blank"
    >
      <component
        :is="socialMediaIcons[props.link.name]"
        class="h-6 w-6"
        viewBox="0 0 57 57"
      />
    </a>
  </span>
</template>
